<template>
  <div class="page">
    <img class="top-img" :src="require('@/assets/title.png')" alt="">
    <div class="top-title">博乐市润景智能垃圾回收处理大数据平台</div>

    <div class="icon-wrap">
      <div class="icon-box center" @click="goRecyclingData">
        <img class="icon" :src="require('@/assets/u13211.svg')" />
        <img class="main-icon" src="@/assets/u13203.png" />
        <div class="label">回收数据总览</div>
      </div>

      <div v-for="(item, index) in surroundIcons" :key="index" class="icon-box surround" :style="getPosition(index)"
        @mouseenter="item.hover = true" @mouseleave="item.hover = false" @click="goToPage(item.path)">
        <img class="base" :src="item.hover ? hoverBase : baseIcon" />
        <img class="icon" :src="item.src" />
        <div class="label">{{ item.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainPage',
  data() {
    return {
      baseIcon: require("@/assets/u13205.png"),
      hoverBase: require("@/assets/u13204.png"),
      surroundIcons: [
        { src: require("@/assets/u13208.svg"), label: "满溢系统", path: 'DeviceInfo', hover: false },
        { src: require("@/assets/u13209.svg"), label: "设备管理", path: 'orderSystem', hover: false },
        { src: require("@/assets/u13210.svg"), label: "监控巡检", path: 'MonitoringInspection', hover: false },
        { src: require("@/assets/u13223.svg"), label: "数据分析", path: 'outside', hover: false },
        { src: require("@/assets/u13220.svg"), label: "合作机构", path: 'partners', hover: false },
        { src: require("@/assets/u13222.svg"), label: "车辆管理", path: 'deviceMonitor', hover: false }
      ]

    };
  },
  methods: {
    getPosition(index) {
      const offset = [
        { top: "-180px", left: "-240px" },
        { top: "-180px", left: "240px" },
        { top: "0", left: "-390px" },
        { top: "0", left: "390px" },
        { top: "230px", left: "-240px" },
        { top: "230px", left: "240px" }
      ];
      return {
        top: offset[index].top,
        left: offset[index].left
      };
    },
    goRecyclingData() {
      const targetPath = '/recycling-data';
      if (this.$route.path !== targetPath) {
        this.$router.push({ name: 'RecyclingData' });
      }
    },
    goToPage(routeName) {
      if (this.$route.name !== routeName) {
        this.$router.push({ name: routeName });
      }
    }
  }
};
</script>

<style scoped>
/* 把你原来 App.vue 的样式粘贴过来 */
.page {
  background-image: url(~@/assets/bg.jpg);
  background-size: cover;
  background-position: center;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

.top-title {
  color: #fff;
  font-size: 32px;
  text-align: center;
  position: absolute;
  top: 0;
  left: 35.5%;
}

.top-img {
  position: relative;
}

.icon-wrap {
  position: absolute;
  top: 60%;
  left: 56.5%;
  transform: translate(-50%, -50%) scale(1.3);
  transform-origin: center center;
}

.icon-box {
  position: absolute;
  text-align: center;
  cursor: pointer;
}

.icon-box.center {
  position: relative;
  top: 56px;
  left: 100px;
  transform: translate(-50%, -50%);
}

.main-icon {
  width: 360px;
}

.base {
  width: 200px;
  transition: 0.3s ease;
}

.icon {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 80px;
}

.label {
  color: #00ffff;
  margin-top: 12px;
  font-size: 20px;
}
</style>
